module.exports = __webpack_public_path__ + "img/_blog3.486ca7d2.jpg";